'use es6';

import { hsvideoConfig } from '../constants/hsvideo';
import { isEditableVideo } from '../utils/video';
import { getDimensionsChangeHandler, getLayoutChangeHandler, getMarginChangeHandler, getPlayerColorChangeHandler } from './handlers';
import { getVideoPluginSetting } from './util';
export function addEventListeners(editor) {
  const updateAlignment = getLayoutChangeHandler(editor);
  editor.on('hsAlignmentChange', ({
    target,
    alignment
  }) => {
    if (!isEditableVideo(editor, target)) return;
    updateAlignment(target, alignment);
  });
  const updatedPlayerColor = getPlayerColorChangeHandler(editor);
  editor.on('hsFillColorChange', ({
    target,
    color
  }) => {
    if (!isEditableVideo(editor, target)) return;
    updatedPlayerColor(target, color.color);
  });
  const updateMargin = getMarginChangeHandler(editor);
  editor.on('hsMarginChange', ({
    target,
    margin
  }) => {
    if (!isEditableVideo(editor, target)) return;
    updateMargin(target, margin);
  });
  const maxContainerWidth = getVideoPluginSetting(editor, hsvideoConfig.MAX_DIMENSION_WIDTH);
  const updateDimensions = getDimensionsChangeHandler(editor, maxContainerWidth);
  editor.on('hsDimensionChange', ({
    target,
    dimensions = {}
  }) => {
    if (!isEditableVideo(editor, target)) return;
    updateDimensions(target, dimensions);
  });
}